import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';

export const Navbar = () => {
  const { t } = useLanguage();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAFAF7]/70 border-b border-[#E3E5DF]/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link 
            to="/" 
            data-testid="nav-logo"
            className="text-3xl text-[#8A9A86] hover:text-[#7A8A76] transition-colors leading-none"
            style={{fontFamily: '"Dancing Script", cursive', fontWeight: 600}}
          >
            Curtigghiu
          </Link>

          <div className="flex items-center gap-8">
            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/"
                data-testid="nav-home"
                className={`text-sm uppercase tracking-[0.2em] transition-colors ${
                  isActive('/') 
                    ? 'text-[#8A9A86] font-medium' 
                    : 'text-[#2C302E]/70 hover:text-[#8A9A86]'
                }`}
                style={{fontFamily: 'Manrope, sans-serif'}}
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/rooms"
                data-testid="nav-rooms"
                className={`text-sm uppercase tracking-[0.2em] transition-colors ${
                  isActive('/rooms') 
                    ? 'text-[#8A9A86] font-medium' 
                    : 'text-[#2C302E]/70 hover:text-[#8A9A86]'
                }`}
                style={{fontFamily: 'Manrope, sans-serif'}}
              >
                {t('nav.rooms')}
              </Link>
              <Link
                to="/admin"
                data-testid="nav-admin"
                className={`text-sm uppercase tracking-[0.2em] transition-colors ${
                  isActive('/admin') 
                    ? 'text-[#8A9A86] font-medium' 
                    : 'text-[#2C302E]/70 hover:text-[#8A9A86]'
                }`}
                style={{fontFamily: 'Manrope, sans-serif'}}
              >
                {t('nav.admin')}
              </Link>
            </div>

            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </nav>
  );
};
